import moment from 'moment';

/**
 * Returns a short label for the selected date for use in chart titles
 *
 * @param selectedDate - The currently selected date
 * @returns "(Today)", "(Yesterday)", or "(DD/MM/YY)"
 *
 * @example
 * getDateLabel(new Date()) // returns "(Today)"
 * getDateLabel(moment().subtract(1, 'day').toDate()) // returns "(Yesterday)"
 * getDateLabel(moment('2026-01-15').toDate()) // returns "(15/01/26)"
 */
export const getDateLabel = (selectedDate: Date | null | undefined): string => {
  if (!selectedDate) return '';

  const selected = moment(selectedDate).startOf('day');
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');

  if (selected.isSame(today, 'day')) {
    return '(Today)';
  }

  if (selected.isSame(yesterday, 'day')) {
    return '(Yesterday)';
  }

  return `(${selected.format('DD/MM/YY')})`;
};

export default getDateLabel;
